var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
__name(_slicedToArray, "_slicedToArray");
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
__name(_nonIterableRest, "_nonIterableRest");
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
__name(_unsupportedIterableToArray, "_unsupportedIterableToArray");
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
__name(_arrayLikeToArray, "_arrayLikeToArray");
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = false;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true) ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
__name(_iterableToArrayLimit, "_iterableToArrayLimit");
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
__name(_arrayWithHoles, "_arrayWithHoles");
import React, { useCallback, useEffect, useState } from "react";
import { Heading, Button } from "@riseart/common";
import { CloseIcon } from "@riseart/icons";
import { Wrapper } from "../../sections/Wrapper";
import { overlayBarCls, overlayBarHeaderCls } from "./Bar.less";
var OverlayBar = /* @__PURE__ */ __name(function OverlayBar2(_ref) {
  var _ref$controlled = _ref.controlled, controlled = _ref$controlled === void 0 ? true : _ref$controlled, _ref$opened = _ref.opened, opened = _ref$opened === void 0 ? true : _ref$opened, title = _ref.title, children = _ref.children, onClose = _ref.onClose;
  var _useState = useState(opened), _useState2 = _slicedToArray(_useState, 2), isOpened = _useState2[0], setIsOpened = _useState2[1];
  useEffect(function() {
    if (!controlled) {
      setIsOpened(opened);
    }
  }, [opened, controlled]);
  var handleCloseClick = useCallback(function() {
    if (controlled) {
      setIsOpened(false);
    }
    if (typeof onClose === "function") {
      onClose();
    }
  }, [controlled, onClose]);
  return isOpened ? /* @__PURE__ */ React.createElement("section", {
    className: overlayBarCls
  }, /* @__PURE__ */ React.createElement(Wrapper, null, /* @__PURE__ */ React.createElement("header", {
    className: overlayBarHeaderCls
  }, /* @__PURE__ */ React.createElement(Heading, {
    tag: "h3",
    level: "3"
  }, title), /* @__PURE__ */ React.createElement(Button, {
    onClick: handleCloseClick,
    type: "link",
    icon: /* @__PURE__ */ React.createElement(CloseIcon, null)
  })), /* @__PURE__ */ React.createElement("div", null, children))) : null;
}, "OverlayBar");
export {
  OverlayBar
};
